import ScrollView from 'devextreme-react/scroll-view';
import React, { useState } from 'react';
import { useParams } from 'react-router-dom';
import PhuHuynhChildList from '../../components/phu-huynh-child-list';
import PhuHuynhCSKH from '../../components/phu-huynh-cskh';
import PhuHuynhFamily from '../../components/phu-huynh-family';
import PhuHuynhInfo from '../../components/phu-huynh-info';
import styles from "./PhuHuynhProfilePage.module.css";
import { Confirm } from 'semantic-ui-react';
import { useCommonContext } from '../../contexts/common';
import { quanHeGiaDinhApi } from '../../api/quanHeGiaDinhApi';
import { showNotify } from '../../helpers/toast';

const PhuHuynhProfilePage = () => {
    const { id } = useParams();
    const { translate } = useCommonContext();

    // const [phuHuynhSelectedId, setPhuHuynhSelectedId] = useState(parseInt(id) || 0);
    // const [hocSinhSelectedId, setHocSinhSelectedId] = useState(0);
    // const [hoSoSurveySelectedId, setHoSoSurveySelectedId] = useState(0);
    const [count, setCount] = useState(0);
    const [quanhes, setQuanHes] = useState([]);
    const [is_show_delete_quanhe_modal, set_is_show_delete_quanhe_modal] = useState(false);

    const [selected, setSelected] = useState({
        phuHuynhSelectedId: parseInt(id),
        hocSinhSelectedId: 0,
        hoSoSurveySelectedId: 0
    })
    const { phuHuynhSelectedId, hocSinhSelectedId, hoSoSurveySelectedId } = selected;
    const onSelectedChanged = (data) => {
        setSelected(data);
    }
    const confirmDeleteQHGD = async (data) => {
        const res = await quanHeGiaDinhApi.DeleteQHGD(data);
        if (res.is_success) {
            set_is_show_delete_quanhe_modal(false);
            showNotify({ text: "Xóa thành công", type: 'success' });
            setCount(count + 1);

        } else {
            showNotify({ text: res.message, type: 'error' });
        }
    };
    return (
        <div>
            <div className={styles.container}>
                <div className={styles.left_side}>
                    <ScrollView height={window.innerHeight - 100}>
                        <div className={styles.phuhuynh_info}>
                            <PhuHuynhInfo id={parseInt(id)} isSelected={phuHuynhSelectedId == parseInt(id)} onSelected={() => {
                                onSelectedChanged({
                                    hocSinhSelectedId: 0,
                                    phuHuynhSelectedId: parseInt(id),
                                    hoSoSurveySelectedId: 0
                                })
                            }} />
                        </div>
                        <div className={styles.phuhuynh_family}>
                            <PhuHuynhFamily id={parseInt(id)} />
                        </div>
                        <div className={styles.phuhuynh_childlist}>
                            <PhuHuynhChildList id={parseInt(id)}
                                hocSinhSelectedId={selected.hocSinhSelectedId}
                                countToRerender={count}
                                onSelected={(hocSinhSelectedId) => {
                                    onSelectedChanged({
                                        phuHuynhSelectedId: 0,
                                        hocSinhSelectedId: hocSinhSelectedId,
                                        hoSoSurveySelectedId: -1
                                    })
                                }}
                                onDeleted={(phuHuynhId, hocSinhSelectedId) => {
                                    const data = { phuHuynhId: phuHuynhId, hocSinhId: hocSinhSelectedId };
                                    setQuanHes(data);
                                    set_is_show_delete_quanhe_modal(true);
                                }}
                            />
                        </div>
                        <Confirm
                            open={is_show_delete_quanhe_modal}
                            dimmer={'blurring'}
                            header={translate('Lưu ý')}
                            content={translate('Bạn có chắc chắn muốn xóa học sinh ?')}
                            size="mini"
                            cancelButton={() => {
                                return (
                                    <button
                                        onClick={() => {
                                            set_is_show_delete_quanhe_modal(false);
                                        }}
                                        className="p-btn p-btn-sm"
                                    >
                                        {translate('Đóng')}
                                    </button>
                                );
                            }}
                            confirmButton={() => {
                                return (
                                    <button
                                        onClick={() => {
                                            confirmDeleteQHGD(quanhes);
                                        }}
                                        className="p-btn p-btn-sm p-strawberry margin-left-10 p-white-color p-white-color"
                                    >
                                        {translate('Xóa học sinh')}
                                    </button>
                                );
                            }}
                        />
                        {/* <div className={styles.phuhuynh_childlist}>
                            <PhuHuynhChildSurveyList id={parseInt(id)}
                                hoSoSurveySelectedId={selected.hoSoSurveySelectedId}
                                onSelected={(hoSoSurveySelectedId) => {
                                    onSelectedChanged({
                                        phuHuynhSelectedId: 0,
                                        hocSinhSelectedId: -1,
                                        hoSoSurveySelectedId: hoSoSurveySelectedId
                                    })
                                }}
                            />
                        </div> */}
                    </ScrollView>

                </div>
                <div className={styles.right_side}>
                    <div className={styles.right_side_container}>
                        <PhuHuynhCSKH ts_phuhuynh_id={parseInt(id)}
                            ts_hocsinh_id={hocSinhSelectedId}
                            ts_hoso_survey_id={hoSoSurveySelectedId}
                            onGhiDanhSuccess={() => {
                                //child list phải tải lại
                                setCount(count + 1)
                            }}
                        />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default PhuHuynhProfilePage;